// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FacultyCardBasicInfo_basic-info__\\+fT4C {
  width: 100%;
}
.FacultyCardBasicInfo_basic-info__\\+fT4C .FacultyCardBasicInfo_tabs__5Ekz4 {
  min-height: 0;
  border-bottom: 1px solid var(--light-grey);
  overflow-x: scroll;
}
.FacultyCardBasicInfo_basic-info__\\+fT4C .FacultyCardBasicInfo_tabs--item__Z5iAO {
  min-width: 0;
  min-height: 0;
  text-transform: initial;
  font-size: 13px;
}
.FacultyCardBasicInfo_basic-info__\\+fT4C .FacultyCardBasicInfo_tabs--item__Z5iAO.FacultyCardBasicInfo_selected__yf9WU {
  color: var(--secondary-color);
}
.FacultyCardBasicInfo_basic-info__\\+fT4C .FacultyCardBasicInfo_tabs--indicator__AckDY {
  background-color: var(--secondary-color);
}
.FacultyCardBasicInfo_basic-info__\\+fT4C .FacultyCardBasicInfo_tabs--content__RSTHW {
  padding: 8px;
  max-height: 400px;
  overflow-y: scroll;
}
.FacultyCardBasicInfo_basic-info__\\+fT4C .FacultyCardBasicInfo_venues-wrapper__xLok8 {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.FacultyCardBasicInfo_basic-info__\\+fT4C .FacultyCardBasicInfo_venue-card__doWDk {
  transition: box-shadow 0.2s ease-in-out !important;
}
.FacultyCardBasicInfo_basic-info__\\+fT4C .FacultyCardBasicInfo_venue-card__doWDk:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
}
.FacultyCardBasicInfo_basic-info__\\+fT4C .FacultyCardBasicInfo_card-content__jQI5S {
  padding: 24px !important;
}
.FacultyCardBasicInfo_basic-info__\\+fT4C .FacultyCardBasicInfo_card-layout__HeO-v {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.FacultyCardBasicInfo_basic-info__\\+fT4C .FacultyCardBasicInfo_venue-info__NoNgw {
  flex: 1 1;
}
.FacultyCardBasicInfo_basic-info__\\+fT4C .FacultyCardBasicInfo_venue-name__uwnah {
  font-weight: 600 !important;
  margin-bottom: 8px !important;
}
.FacultyCardBasicInfo_basic-info__\\+fT4C .FacultyCardBasicInfo_venue-stats__ARAJS {
  display: flex;
  gap: 24px;
}
.FacultyCardBasicInfo_basic-info__\\+fT4C .FacultyCardBasicInfo_stat-item__mv\\+SA {
  color: rgba(0, 0, 0, 0.6) !important;
}
.FacultyCardBasicInfo_basic-info__\\+fT4C .FacultyCardBasicInfo_stat-item__mv\\+SA strong {
  color: rgba(0, 0, 0, 0.87);
}
.FacultyCardBasicInfo_basic-info__\\+fT4C .FacultyCardBasicInfo_rank-display__3LAGR {
  text-align: right;
}
.FacultyCardBasicInfo_basic-info__\\+fT4C .FacultyCardBasicInfo_rank-number__i7wks {
  font-weight: bold !important;
  color: rgba(0, 0, 0, 0.87) !important;
}
.FacultyCardBasicInfo_basic-info__\\+fT4C .FacultyCardBasicInfo_more-information__fLYpn {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.FacultyCardBasicInfo_basic-info__\\+fT4C .FacultyCardBasicInfo_more-information__fLYpn .FacultyCardBasicInfo_more-information--body__KOEo2 {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.FacultyCardBasicInfo_basic-info__\\+fT4C .FacultyCardBasicInfo_more-information__fLYpn .FacultyCardBasicInfo_more-information--body--title__3uWVd {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  color: var(--info-color);
}
.FacultyCardBasicInfo_basic-info__\\+fT4C .FacultyCardBasicInfo_more-information__fLYpn .FacultyCardBasicInfo_more-information--body--content__7Bxx1 {
  margin-left: 20px;
}
.FacultyCardBasicInfo_basic-info__\\+fT4C .FacultyCardBasicInfo_more-information__fLYpn .FacultyCardBasicInfo_more-information--body--content--item__lngGL {
  line-height: normal;
  font-size: 14px;
  color: var(--grey-text);
}
.FacultyCardBasicInfo_basic-info__\\+fT4C .FacultyCardBasicInfo_more-information__fLYpn .FacultyCardBasicInfo_more-information--body--content--item--statistics__pEyxZ {
  display: flex;
  align-items: center;
  gap: 4px;
}
.FacultyCardBasicInfo_basic-info__\\+fT4C .FacultyCardBasicInfo_more-information__fLYpn .FacultyCardBasicInfo_more-information--body--content--item--statistics__pEyxZ svg {
  width: 16px;
  height: 16px;
}
.FacultyCardBasicInfo_basic-info__\\+fT4C .FacultyCardBasicInfo_more-information__fLYpn .FacultyCardBasicInfo_more-information--body--content--item--statistics__pEyxZ svg path {
  stroke: var(--accent-color);
}`, "",{"version":3,"sources":["webpack://./src/Explore/Components/FacultyCard/BasicInfo/FacultyCardBasicInfo.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;AAAE;EACE,aAAA;EACA,0CAAA;EACA,kBAAA;AAEJ;AAAI;EACE,YAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;AAEN;AAAM;EACE,6BAAA;AAER;AAEI;EACE,wCAAA;AAAN;AAGI;EACE,YAAA;EACA,iBAAA;EACA,kBAAA;AADN;AAIE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAFJ;AAKE;EACE,kDAAA;AAHJ;AAKI;EACE,mDAAA;AAHN;AAOE;EACE,wBAAA;AALJ;AAQE;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;AANJ;AASE;EACE,SAAA;AAPJ;AAUE;EACE,2BAAA;EACA,6BAAA;AARJ;AAWE;EACE,aAAA;EACA,SAAA;AATJ;AAYE;EACE,oCAAA;AAVJ;AAYI;EACE,0BAAA;AAVN;AAcE;EACE,iBAAA;AAZJ;AAeE;EACE,4BAAA;EACA,qCAAA;AAbJ;AAgBE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAdJ;AAiBM;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAfR;AAgBQ;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,wBAAA;AAdV;AAiBQ;EACE,iBAAA;AAfV;AAiBU;EACE,mBAAA;EACA,eAAA;EACA,uBAAA;AAfZ;AAiBY;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAfd;AAiBc;EACE,WAAA;EACA,YAAA;AAfhB;AAgBgB;EACE,2BAAA;AAdlB","sourcesContent":[".basic-info {\n  width: 100%;\n  .tabs {\n    min-height: 0;\n    border-bottom: 1px solid var(--light-grey);\n    overflow-x: scroll;\n\n    &--item {\n      min-width: 0;\n      min-height: 0;\n      text-transform: initial;\n      font-size: 13px;\n\n      &.selected {\n        color: var(--secondary-color);\n      }\n    }\n\n    &--indicator {\n      background-color: var(--secondary-color);\n    }\n\n    &--content {\n      padding: 8px;\n      max-height: 400px;\n      overflow-y: scroll;\n    }\n  }\n  .venues-wrapper {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  .venue-card {\n    transition: box-shadow 0.2s ease-in-out !important;\n\n    &:hover {\n      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;\n    }\n  }\n\n  .card-content {\n    padding: 24px !important;\n  }\n\n  .card-layout {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n  }\n\n  .venue-info {\n    flex: 1;\n  }\n\n  .venue-name {\n    font-weight: 600 !important;\n    margin-bottom: 8px !important;\n  }\n\n  .venue-stats {\n    display: flex;\n    gap: 24px;\n  }\n\n  .stat-item {\n    color: rgba(0, 0, 0, 0.6) !important;\n\n    strong {\n      color: rgba(0, 0, 0, 0.87);\n    }\n  }\n\n  .rank-display {\n    text-align: right;\n  }\n\n  .rank-number {\n    font-weight: bold !important;\n    color: rgba(0, 0, 0, 0.87) !important;\n  }\n\n  .more-information {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n\n    .more-information {\n      &--body {\n        display: flex;\n        flex-direction: column;\n        gap: 4px;\n        &--title {\n          display: flex;\n          align-items: center;\n          gap: 8px;\n          font-size: 16px;\n          font-weight: 600;\n          color: var(--info-color);\n        }\n\n        &--content {\n          margin-left: 20px;\n\n          &--item {\n            line-height: normal;\n            font-size: 14px;\n            color: var(--grey-text);\n\n            &--statistics {\n              display: flex;\n              align-items: center;\n              gap: 4px;\n\n              svg {\n                width: 16px;\n                height: 16px;\n                path {\n                  stroke: var(--accent-color);\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"basic-info": `FacultyCardBasicInfo_basic-info__+fT4C`,
	"tabs": `FacultyCardBasicInfo_tabs__5Ekz4`,
	"tabs--item": `FacultyCardBasicInfo_tabs--item__Z5iAO`,
	"selected": `FacultyCardBasicInfo_selected__yf9WU`,
	"tabs--indicator": `FacultyCardBasicInfo_tabs--indicator__AckDY`,
	"tabs--content": `FacultyCardBasicInfo_tabs--content__RSTHW`,
	"venues-wrapper": `FacultyCardBasicInfo_venues-wrapper__xLok8`,
	"venue-card": `FacultyCardBasicInfo_venue-card__doWDk`,
	"card-content": `FacultyCardBasicInfo_card-content__jQI5S`,
	"card-layout": `FacultyCardBasicInfo_card-layout__HeO-v`,
	"venue-info": `FacultyCardBasicInfo_venue-info__NoNgw`,
	"venue-name": `FacultyCardBasicInfo_venue-name__uwnah`,
	"venue-stats": `FacultyCardBasicInfo_venue-stats__ARAJS`,
	"stat-item": `FacultyCardBasicInfo_stat-item__mv+SA`,
	"rank-display": `FacultyCardBasicInfo_rank-display__3LAGR`,
	"rank-number": `FacultyCardBasicInfo_rank-number__i7wks`,
	"more-information": `FacultyCardBasicInfo_more-information__fLYpn`,
	"more-information--body": `FacultyCardBasicInfo_more-information--body__KOEo2`,
	"more-information--body--title": `FacultyCardBasicInfo_more-information--body--title__3uWVd`,
	"more-information--body--content": `FacultyCardBasicInfo_more-information--body--content__7Bxx1`,
	"more-information--body--content--item": `FacultyCardBasicInfo_more-information--body--content--item__lngGL`,
	"more-information--body--content--item--statistics": `FacultyCardBasicInfo_more-information--body--content--item--statistics__pEyxZ`
};
export default ___CSS_LOADER_EXPORT___;
